import React from 'react';
export function PrivacyPolicy() {
  return <>
      <p data-id="element-87">
        We respect your privacy and are committed to protecting your personal
        information.
      </p>

      <div className="space-y-4" data-id="element-88">
        <div data-id="element-89">
          <h3 className="font-medium text-gray-900 mb-2" data-id="element-90">What we collect</h3>
          <p data-id="element-91">
            When you place an order, we collect your name, date of birth,
            address, Snapchat username, and uploaded photo. This information is
            used solely to personalise your candle and deliver your order.
          </p>
        </div>

        <div data-id="element-92">
          <h3 className="font-medium text-gray-900 mb-2" data-id="element-93">
            How we use your data
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-2" data-id="element-94">
            <li data-id="element-95">To create your personalised candle design</li>
            <li data-id="element-96">To contact you about your order if needed</li>
            <li data-id="element-97">To deliver your product</li>
          </ul>
        </div>

        <div data-id="element-98">
          <h3 className="font-medium text-gray-900 mb-2" data-id="element-99">Data security</h3>
          <p data-id="element-100">
            All information is stored securely and never sold or shared with
            third parties. Photo uploads are used exclusively for the design
            process and are permanently deleted after your final product is
            delivered.
          </p>
        </div>

        <div data-id="element-101">
          <h3 className="font-medium text-gray-900 mb-2" data-id="element-102">Your rights</h3>
          <p data-id="element-103">
            You may request data deletion or access to your stored information
            at any time by contacting us at: contact@thecandle.co.uk
          </p>
        </div>
      </div>
    </>;
}
export function RefundPolicy() {
  return <>
      <p data-id="element-104">
        Because each candle is custom-made and personalised, all sales are
        final.
      </p>

      <p data-id="element-105">
        If your candle arrives damaged or defective, contact us within 48 hours
        of delivery and we will replace it free of charge.
      </p>

      <p data-id="element-106">
        We do not offer refunds for incorrect information submitted during
        checkout (e.g., wrong address).
      </p>
    </>;
}
export function ShippingPolicy() {
  return <>
      <p data-id="element-107">All candles are made to order.</p>

      <div className="space-y-2" data-id="element-108">
        <p data-id="element-109">
          <strong data-id="element-110">Processing time:</strong> 1 business day
        </p>
        <p data-id="element-111">
          <strong data-id="element-112">Shipping (UK):</strong> 10-15 days
        </p>
      </div>

      <p data-id="element-113">You will receive tracking information once your order ships.</p>
    </>;
}